<template>
  <div>
    <div class="modal-header">
      <button type="button" class="close" @click="$emit('close')">x</button>
    </div>
    <b-card class="modal-editerJustif">
      <p>Justification pour la ligne d'anomalie : {{idAnomalie}}</p>

      <p class="titreJustif">Veuillez renseigner le type de la justification:</p>
      <label for="justification">justification</label>
      <input type="radio" v-model="type" value="justification" class="m-1" @change="toggleVisibility('justif', true); toggleVisibility('validation', false)">
      <label for="correction">correction</label>
      <input type="radio" v-model= "type" value="correction" class="m-1" @change="toggleVisibility('justif', false); toggleVisibility('validation', true)">

      <div id="justif" v-show="isVisible['justif']">
        <b-form-group id="input-group-5" label="Si cette anomalie possède une justification veuillez la saisir ci-dessous:"
                      label-for="textarea-large">
          <b-form-textarea id="textarea-large"  type="textarea" v-model="justificationText" rows="4"></b-form-textarea>
        </b-form-group>
      </div>

      <div>
        <b-button pill v-on:click="updateJustificationOffline" class="nav-link1 m-2">Modifier</b-button>
        <b-button pill  v-on:click="deleteJustificationOffline" class="nav-link2 m-2">Supprimer</b-button>
        <b-button pill  @click="$emit('close')" class="nav-link4 m-2">Annuler</b-button>
      </div>

    </b-card>
  </div>
</template>

<script>
import useEditerJustifWithoutConnexion from "@/composition/RapportsSansConnexion/editerJustifWithoutConnexion";
export default {
  name:"EditerJustif",

  props: {
    idAnomalie:{
      type:Number

    }
  },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup(props, { emit }) {
    return useEditerJustifWithoutConnexion(props, {emit})
  }
};
</script>

<style>

.modal-editerJustif{
  background-color: #17a2b8;
}

.modal-header {
  color: rgb(122, 121, 121);
}

.titreJustif{
  text-decoration: underline;
}

</style>